<template>
  <div class="content">
    <div class="head">
      <div class="searchOne">
        <el-input v-model="queryParams.name" placeholder="规则名称"  @keyup.enter.native="search" clearable></el-input>
      </div>
      <span class="span-but">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="resetForm">重置</el-button>
        <el-button type="primary" size="medium" icon="el-icon-plus" @click="adds">新增</el-button>
      </span>
    </div>
    <div class="content-class">
      <div style="margin-top: 10px">
        <el-table :data="tableData" border>
          <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
          <el-table-column prop="name" label="规则名称" align="center"></el-table-column>
          <el-table-column prop="operationNames" label="扣费运营商" align="center">
            <template slot-scope="{row}">
              <el-tag v-for="(item,index) in row.operationNames" :key="index" style="margin: 3px;">{{item}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="cardStatus" label="卡状态" align="center">
            <template slot-scope="{row}">
              <el-tag v-for="(item,index) in row.cardStatus" :key="index" style="margin: 3px;" type="warning">{{item}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="chargeMoney" label="扣费金额" align="center"></el-table-column>
          <el-table-column prop="chargeDate" label="扣费日期" align="center"></el-table-column>
          <el-table-column prop="createTime" label="创建日期" align="center"></el-table-column>
          <el-table-column label="操作" width="230" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" plain icon="el-icon-edit" @click="editRow(scope.row.id)" >编辑</el-button>
							<el-button size="mini" type="danger"  plain icon="el-icon-delete" @click="deleteRow(scope.row.id)" >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="block" style="margin-top: 30px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" width="600px" append-to-body v-dialogDrag>
      <el-form :model="form" label-width="80px" ref="form" :rules="rules">
        <el-form-item label="规则名称:" prop="name" label-width="100px">
          <el-input v-model="form.name" autocomplete="off" style="width: 85%" placeholder="请输入规则名称"></el-input>
        </el-form-item>
        <el-form-item label="扣费运营商:" prop="operationTypes" label-width="100px">
          <el-select v-model="form.operationTypes" multiple default-first-option filterable placeholder="请选择扣费运营商" style="width: 85%">
            <el-option v-for="item in optPackage" :key="item.value" :label="item.label" :value="item.value" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="卡状态:" prop="cardStatus" label-width="100px">
          <el-select v-model="form.cardStatus" multiple default-first-option filterable placeholder="请选择卡状态" style="width: 85%">
            <el-option v-for="item in state" :key="item.cardStatus" :label="item.operationName" :value="item.cardStatus" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="扣费金额:" prop="chargeMoney" label-width="100px">
          <el-input v-model="form.chargeMoney" autocomplete="off" style="width: 85%" placeholder="请输入扣费金额"></el-input>
        </el-form-item>
        <el-form-item label="扣费日期:" prop="chargeDate" label-width="100px">
          <el-input v-model="form.chargeDate" autocomplete="off" style="width: 85%" placeholder="请输入扣费日期"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancelDialog()">取消</el-button>
        <el-button type="success" @click="saveInfo()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { saveStatusRule } from "@/api/api.js"; //状态扣款规则保存
import { productList } from "@/api/api.js"; //套餐下拉
import { autoDeductionStatusPage } from "@/api/api.js"; //状态扣款规则分页展示
import { autoDeductionStatusInfo } from "@/api/api.js"; //编辑状态扣款规则详情
import { autoDeductionUpdateStatusRule } from "@/api/api.js"; //编辑状态扣款规则的保存
import { autoDeductionStatusRuleDelete } from "@/api/api.js"; //状态款规则的删除
export default {
  data() {
    var validaterq = (rule, value, callback) => {
      if(value){
        if(/^[1-9]$|[1-2][0-9]$|3[0-1]$/.test(value) == false){
          callback(new Error("请输入1到31之间的值"));
        }else{
          callback();
        }
      }else{
        callback(new Error('请输入扣费日期'));
      }
    };
    return{
      queryParams:{},
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      searchTime:[],
      // 弹窗部分
      title:"",
      dialog:false,
      form:{},
      optPackage: [
        { value: "1",label: "中国电信" },
        { value: "2",label: "中国移动" },
        { value: "3",label: "中国联通" }
      ],
      rules:{
        name:[
          { required: true, message: "请输入规则名称", trigger: "blur" }
        ],
        operationTypes:[
          { required: true, message: "请选择扣费运营商", trigger: "blur" }
        ],
        cardStatus:[
          { required: true, message: "请选择卡状态", trigger: "blur" }
        ],
        chargeMoney:[
          { required: true, message: "请输入扣费金额", trigger: "blur" }
        ],
        chargeDate:[
          { required: true,validator: validaterq, trigger: 'blur' }
        ]
      },
      // 状态
      state: [
        {
          cardStatus: "1",
          operationName: "库存"
        },
        {
          cardStatus: "2",
          operationName: "待激活"
        },
        {
          cardStatus: "3",
          operationName: "可测试"
        },
        {
          cardStatus: "4",
          operationName: "已激活"
        },
        {
          cardStatus: "5",
          operationName: "已停机"
        },
        {
          cardStatus: "6",
          operationName: "预销户"
        },
        {
          cardStatus: "7",
          operationName: "已销户"
        },
        {
          cardStatus: "8",
          operationName: "停机保号"
        },
        {
          cardStatus: "9",
          operationName: "已补卡"
        }
      ],
    }
  },
  methods: {
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetForm() {
      for (var i in this.queryParams) {
        this.queryParams[i] = null;
      }
      this.initData();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    // 获取列表的数据
    initData(){
      let params= {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      }
      autoDeductionStatusPage(params).then(res=>{
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.tableData.map((item,index)=>{
            item.ids = index + 1
          })
        }
      })
    },
    // 新增
    adds(){
      this.title = "新增状态规则";
      this.dialog = true;
      this.form = {};
    },
    // 编辑
    editRow(id){
      this.title = "编辑状态规则";
      this.dialog = true;
      let params = {
        id:id
      }
      autoDeductionStatusInfo(params).then(res=>{
        this.form = res.data.data;
      })
    },
    // 删除
    deleteRow(id){
      let params = {
        id:id
      }
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
			}).then(() => {
        autoDeductionStatusRuleDelete(params).then(res=>{
          if (res.data.code == 200) {
            this.$notify({
              title: '成功',
              message: '删除状态规则成功',
              type: 'success'
            });
            this.initData();
          }else{
            this.$message.error(res.data.message);
          }
        })
      })
    },
    // 弹窗的取消
    cancelDialog(){
      this.dialog = false;
    },
    // 弹窗的保存
    saveInfo(){
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.title == "新增状态规则") {
            let params ={
              ...this.form
            }
            saveStatusRule(params).then(res=>{
              if(res.data.code == 200){
                this.$notify({
                  title: '成功',
                  message: '新增状态规则成功',
                  type: 'success'
                });
                this.dialog = false;
                this.initData();
              }
            })
          }else{
            let params ={
              ...this.form
            }
            autoDeductionUpdateStatusRule(params).then(res=>{
              if(res.data.code == 200){
                this.$notify({
                  title: '成功',
                  message: '编辑状态规则成功',
                  type: 'success'
                });
                this.dialog = false;
                this.initData();
              }
            })
          }
        }
      })
    },
    // 弹窗的x
    dialogClose(){
      this.$refs.form.clearValidate();
      this.dialog = false;
    },
  },
  mounted() {
    this.initData();
  },
  created() {
    
  }
};
</script>
<style scoped lang="less">
.searchOne{
  display: inline-block;
  .el-input{
    margin-right: 30px;
    width:210px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
  }
  .el-date-editor{
    width:450px ;
  }
}
.rotating {
  transform: rotate(90deg);
}
.el-button--small.icon-button-auto {
  padding: 12px 9px;
  position: relative;
  top: -1px;
}
.span-but{
  margin-left: -30px;
  button{
    padding: 10px 20px;
    margin-top: 3px;
    margin-left: 5px;
  }
}
.array-class{
  width: 70%;
  display: flex;
  flex-wrap:wrap;
  margin-top: 5px;
  .el-input{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-date-editor{
    width:450px ;
    margin-top: 15px;
    margin-right: 30px;
  }
}
</style>


